import { Section, SectionTitle, CaseCard } from './shared';

export function FinanceContent() {
  const financeCases = [
    {
      icon: '📈',
      title: 'AI选股系统',
      description: '10分钟打造你的AI选股系统,OpenClaw每日自动筛选5支潜力股',
      tags: ['股票', 'AI分析', '自动化'],
      difficulty: 'intermediate' as const,
      link: 'https://curl.qcloud.com/GbASb3WE',
    },
  ];

  return (
    <div className="space-y-8">
      <Section>
        <SectionTitle>金融投资自动化案例</SectionTitle>
        <p className="text-slate-400 mb-6">
          使用 OpenClaw 构建智能投资分析系统,实现股票筛选、数据分析和投资决策自动化。
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {financeCases.map((caseItem, index) => (
            <CaseCard key={index} {...caseItem} />
          ))}
        </div>
      </Section>

      <Section>
        <div className="bg-cyan-500/10 border border-cyan-500/50 rounded-lg p-6">
          <h3 className="text-lg font-semibold text-cyan-400 mb-3">💡 核心功能</h3>
          <ul className="space-y-2 text-slate-300">
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>每日自动筛选潜力股票</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>AI 分析财务数据和市场趋势</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>生成投资建议和风险评估</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="text-cyan-400 mt-1">•</span>
              <span>实时推送重要市场动态</span>
            </li>
          </ul>
        </div>
      </Section>
    </div>
  );
}